module.exports = __webpack_public_path__ + "assets/media/graffiti-texture-desktop.696c94d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoController/graffiti-texture-desktop.svg
// module id = 3263
// module chunks = 0